import type { ReactNode } from 'react';

type StatCardProps = {
  label: string;
  value: number | string;
  hint?: string;
  accent?: 'default' | 'blue' | 'green' | 'amber' | 'purple';
};

const ACCENT_CLASS = {
  default: '',
  blue: 'stat-card--blue',
  green: 'stat-card--green',
  amber: 'stat-card--amber',
  purple: 'stat-card--purple',
} as const;

export function StatCard({ label, value, hint, accent = 'default' }: StatCardProps) {
  return (
    <article className={`stat-card ${ACCENT_CLASS[accent]}`}>
      <p className="stat-card__label">{label}</p>
      <p className="stat-card__value">{value}</p>
      {hint ? <p className="stat-card__hint">{hint}</p> : null}
    </article>
  );
}

export function StatCardGrid({ children }: { children: ReactNode }) {
  return <div className="stat-card-grid">{children}</div>;
}
